<template>
<tr>
    <th class="sheet-header text-truncate text-capitalize font-weight-regular" style="border-left: 2px solid white">
        {{$t('sheet.sheet_components.room_booked.title')}}
    </th>
    <template v-for="day in inventory">
        <td class="sheet-cell pa-0 text-center">
            <input v-model.lazy="day.booked" class="sheet-input" style="background-color: transparent; outline-color: transparent" readonly />
        </td>
    </template>
</tr>
</template>
<script>
export default {
    props: {
        inventory: [Array, Object]
    },

    data() {
        return {}
    },
    mounted() {},

    methods: {}
}
</script>
